import KeyboardReact from "./components/KeyboardModern";
export * from "./interfaces.d";
export { KeyboardReact };
export default KeyboardReact;
